import React from 'react';
import { connect } from 'react-redux';

import classes from './Seats.scss';

import SeatsNav from './SeatsNav/SeatsNav';
import SeatsMap from './SeatsMap/SeatsMap';

import seatActive from '../../../assets/images/addons/seat-active.png';
import seatUnavailable from '../../../assets/images/addons/seat-unavailable.png';
import seatAvailable from '../../../assets/images/addons/seat-available.png';
import seatPaid from '../../../assets/images/addons/seat-paid.png';


const seats = (props) => {
    return (
        <div className={classes.Container}>
            <div className={classes.Nav}>
                {
                    Object.getOwnPropertyNames(props.seats.O).length === 0 ? <div>
                        <p className="u-fontSize13 u-textColorWhite u-fontWeightRegular">Seat selection is not available for departure flight.</p>
                    </div> : <div>
                        <SeatsNav type='depart' seats={props.seats.O} seatsView={props.seatsViewO} index={props.seatsIndexO} seatsFlow={props.seatsFlow} flow='O'/>
                    </div>
                }
                { props.flightType === "R" ? 
                    Object.getOwnPropertyNames(props.seats.R).length === 0 ? <div>
                        <p className="u-fontSize13 u-textColorWhite u-fontWeightRegular">Seat selection is not available for return flight.</p>
                    </div> : <div>
                    <SeatsNav type='return' seats={props.seats.R} seatsView={props.seatsViewR} index={props.seatsIndexR} seatsFlow={props.seatsFlow} flow='R'/>
                    </div> : null
                }                
            </div>
            { props.seatsLoading ? 
            <div className="ml-auto mr-auto phone-mb-4 phone-mt-4">
                <h2 className={classes.LoadingText}>Loading</h2>
            </div> : <SeatsMap/> }
            <div className={`${classes.PlaneInfo} u-absolute u-flex justify-content-between phone-f-column u-textColorWhite u-fontWeightRegular u-fontSize16`}>
                <div className="u-phoneTextAlignLeft">{props.flightType === 'O' ? props.planeNameO : props.planeNameR}</div>
                <div>
                    <ul className="u-flex phone-f-wrap phone-justify-content-between">
                        <li className="u-flex align-items-center u-lineHeight1 mr-3">
                            <div className="u-width18 mr-1">
                                <img src={seatAvailable} alt="Available" className="u-width100Percent"/>
                            </div>
                            <span className="u-fontSize13">Available Seat</span>
                        </li>
                        <li className="u-flex align-items-center u-lineHeight1 mr-3">
                            <div className="u-width18 mr-1">
                                <img src={seatUnavailable} alt="Occupied" className="u-width100Percent"/>
                            </div>
                            <span className="u-fontSize13">Occupied Seat</span>
                        </li>
                        <li className="u-flex align-items-center u-lineHeight1 mr-3">
                            <div className="u-width18 mr-1">
                                <img src={seatActive} alt="Selected" className="u-width100Percent"/>
                            </div>
                            <span className="u-fontSize13">Selected Seat</span>
                        </li>
                        <li className="u-flex align-items-center u-lineHeight1 mr-3">
                            <div className="u-width18 mr-1">
                                <img src={seatPaid} alt="Paid" className="u-width100Percent"/>
                            </div>
                            <span className="u-fontSize13">Paid Seat</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        seats: state.farePrice.generalData.data.seats,
        seatsViewO: state.farePrice.seatsViewOneWay,
        seatsViewR: state.farePrice.seatsViewReturn,
        seatsIndexO: state.farePrice.seatsViewOneWayVal,
        seatsIndexR: state.farePrice.seatsViewReturnVal,
        seatsFlow: state.farePrice.seatsFlow,
        planeNameO: state.farePrice.flightScheduleOneWay[0].FS[state.farePrice.seatsViewOneWayVal].eq,
        planeNameR: state.farePrice.flightScheduleRoundTrip ? state.farePrice.flightScheduleRoundTrip[0].FS[state.farePrice.seatsViewReturnVal].eq : null,
        seatsLoading: state.seats.loading,
        flightType: state.farePrice.flightType
    }
}

export default connect(mapStateToProps)(seats);


// WEBPACK FOOTER //
// ./src/components/Addons/Seats/Seats.js